// extracted by mini-css-extract-plugin
module.exports = {"Title":"Loading_Title__UVhk5","Body":"Loading_Body__JSyNK"};